/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleFactOwnershipTransitionData
 */
export interface GoogleFactOwnershipTransitionData {
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionData
     */
    transitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionData
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionData
     */
    effectiveFrom?: Date;
}

/**
 * Check if a given object implements the GoogleFactOwnershipTransitionData interface.
 */
export function instanceOfGoogleFactOwnershipTransitionData(value: object): value is GoogleFactOwnershipTransitionData {
    return true;
}

export function GoogleFactOwnershipTransitionDataFromJSON(json: any): GoogleFactOwnershipTransitionData {
    return GoogleFactOwnershipTransitionDataFromJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFactOwnershipTransitionData {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionId': json['transitionId'] == null ? undefined : json['transitionId'],
        'status': json['status'] == null ? undefined : json['status'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
    };
}

export function GoogleFactOwnershipTransitionDataToJSON(json: any): GoogleFactOwnershipTransitionData {
    return GoogleFactOwnershipTransitionDataToJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionDataToJSONTyped(value?: GoogleFactOwnershipTransitionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transitionId': value['transitionId'],
        'status': value['status'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
    };
}

